import React, { useEffect, useState } from 'react';
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    hh: Math.floor(seconds / 3600),
    mm: Math.floor(seconds % 3600 / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="relative z-10 flex flex-col items-center" data-id="element-32" data-mp="3h0z2wwv6xgxl">
      <div className="animate-pulse-red flex h-16 w-16 items-center justify-center rounded-xl border border-rojo/50 font-display text-3xl font-black tabular-nums text-white sm:h-20 sm:w-20 sm:text-4xl" data-id="element-33" data-mp="3h2a913c3z0rv">
        {String(value).padStart(2, '0')}
      </div>
      <span className="mt-2 text-[10px] font-bold uppercase tracking-widest text-white/50" data-id="element-34" data-mp="10c3g9peypw3l">
        {label}
      </span>
    </div>;
}
export function Countdown() {
  const {
    hh,
    mm,
    ss
  } = useCountdown(23 * 3600 + 59 * 60 + 40);
  return <section aria-label="Cuenta regresiva" className="relative w-full overflow-x-hidden bg-ink" data-id="element-35" data-mp="xzc1k06g4loq">
      <div className="mx-auto max-w-3xl px-5 py-8 text-center" data-id="element-36" data-mp="t1topypb5mbg">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-plata" data-id="element-37" data-mp="17py874w6q1va">
          ⏰ Precio de lanzamiento — cierra en:
        </p>

        <div className="relative mt-6 flex items-center justify-center gap-3 sm:gap-5" data-id="element-38" data-mp="12tzq1z1g9g3b">
          <div className="animate-glow-red pointer-events-none absolute inset-y-[-25%] left-1/2 w-[min(16rem,80%)] -translate-x-1/2 rounded-full bg-rojo/40 blur-2xl" aria-hidden="true" data-id="element-39" data-mp="f2kkzyiagkod" />
          <Unit value={hh} label="Horas" data-id="element-40" data-mp="o0nv7yntpv0v" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-41" data-mp="k15hpnyc0m82">:</span>
          <Unit value={mm} label="Min" data-id="element-42" data-mp="1zhmhfijo289w" />
          <span className="font-display text-3xl font-black text-white/30" data-id="element-43" data-mp="1zgkvgj1441de">:</span>
          <Unit value={ss} label="Seg" data-id="element-44" data-mp="1vfiw82773pbf" />
        </div>

        <p className="mt-6 text-sm font-semibold text-white/60" data-id="element-45" data-mp="s5n3eskq9c7f">
          ⚠️ Luego sube a $38. No vuelve a este precio.
        </p>

        <div className="mx-auto mt-6 max-w-md" data-id="element-46" data-mp="x3omvem2fdjf">
          <p className="mb-2 text-left text-xs font-semibold text-white/60" data-id="element-47" data-mp="x6kl741ts48e">
            🔴 Cupos al precio de lanzamiento
          </p>
          <div className="h-3 w-full overflow-hidden rounded-full bg-white/10" data-id="element-48" data-mp="165xthte7qmrj">
            <div className="h-full w-[72%] rounded-full bg-rojo" data-id="element-49" data-mp="9ff64r3plfz5" />
          </div>
          <p className="mt-2 text-right text-xs font-bold text-plata" style={{
          color: "#D61F2B"
        }} data-id="element-50" data-mp="9dc4tax3w0f4">72% tomados — Quedan pocos</p>
        </div>
      </div>
    </section>;
}